import { Injectable, EventEmitter } from '@angular/core';
import { Dictionary } from './dictionary';
import { Utils } from './utils';

@Injectable()
export class DataStore {
    private dataStore:Dictionary;
    private _emitters: Dictionary = {};
    constructor(private utils: Utils) {
        this.dataStore = {}
    }

    
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/utils/datastore.ts